// @ts-nocheck
// Icon registry for per-link composed-forecast icons.
// Mirrors the icons used by the built-in weather entries in the forecast
// dropdown (see forecastSchemaUtils.js) so users can pick a familiar
// forecast-type icon when linking a composed forecast to an asset.

import React from "react";
import { ReactComponent as CloudRaining } from "../../assets/icons/cloud-raining-05.svg";
import { ReactComponent as WindIcon } from "../../assets/icons/wind-02.svg";
import { ReactComponent as SunIcon } from "../../assets/icons/sun.svg";
import { ReactComponent as TemperatureIcon } from "../../assets/icons/thermometer-03.svg";
import { ReactComponent as HumidityIcon } from "../../assets/icons/droplets-01.svg";
import { ReactComponent as SoilMoistureIcon } from "../../assets/icons/divide-02.svg";
import { ReactComponent as SnowflakeIcon } from "../../assets/icons/snowflake-01.svg";
import { ReactComponent as HurricaneIcon } from "../../assets/icons/hurricane-02.svg";

export interface ComposedForecastIconOption {
  value: string;
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const COMPOSED_FORECAST_ICON_OPTIONS: ComposedForecastIconOption[] = [
  { value: "precipitation", label: "Precipitation", Icon: CloudRaining },
  { value: "wind", label: "Wind", Icon: WindIcon },
  { value: "solar", label: "Solar", Icon: SunIcon },
  { value: "temperature", label: "Temperature", Icon: TemperatureIcon },
  { value: "humidity", label: "Humidity", Icon: HumidityIcon },
  { value: "soil_moisture", label: "Soil Moisture", Icon: SoilMoistureIcon },
  { value: "snow_water", label: "Snow Water", Icon: SnowflakeIcon },
  { value: "hurricane", label: "Hurricane", Icon: HurricaneIcon },
];

/** Quick string -> React component lookup for the dashboard render path. */
export const COMPOSED_FORECAST_ICON_MAP: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = COMPOSED_FORECAST_ICON_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.Icon;
  return acc;
}, {} as Record<string, React.FC<React.SVGProps<SVGSVGElement>>>);
